import { Component, OnInit, Input, SimpleChanges, ViewChild } from '@angular/core';
import * as firebase from 'firebase/app';
import { AngularFireDatabase } from 'angularfire2/database';
import { Section31Component } from '../section3-1/section3-1.component';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';

@Component({
  selector: 'app-section3-2',
  templateUrl: './section3-2.component.html',
  styleUrls: ['./section3-2.component.css'],
  providers : [LogisticsService]
})
export class Section32Component implements OnInit {
  @Input("month") month;
  @ViewChild(Section31Component) child;
  currentDate:any;
  branchWiseShipmentsForCurrentMonth:any;
  totalIntransitPerYear:any;
  leadBranchName:any;
  lagBranchName:any;
  customerCount:any;
  credit:any;
  currency:any
  constructor(private db:AngularFireDatabase, private ls:LogisticsService) {
    this.currentDate = new Date();
   }

  ngOnInit() {
    //console.log("month",this.month);
    this.getBranchDetails(this.month);
    this.getNewCustomers(this.month);
    this.getCurrency();
  }
  getCurrency()
  {
    this.ls.currency.subscribe(currency => {
      this.currency = currency;
      //console.log(" getSettings()", currency); 
    });
  }
  getBranchDetails(month)
  {
    var year = this.currentDate.getFullYear();
    this.db.list("branches").snapshotChanges().subscribe(item=>{
      this.totalIntransitPerYear = 0;
      this.branchWiseShipmentsForCurrentMonth = [];
      this.credit = 0;
        item.forEach(element =>{
          firebase.database().ref("shipments").orderByChild("branch").equalTo(element.key).on("value",(snapshot)=>{
            var data = snapshot.val();
            if(data!=null)
            {
              //console.log("snapshot data",data);
                var y = element.payload.toJSON();
                var totalCash = 0;
                var totalShipment = 0;
                for(let i in data)
                {
                  var datesource = null;
                  var datedestination = null;
                  if(data[i].source.date!=null)
                  {
                    datesource = data[i].source.date;
                  }
                if(data[i].destination.date!=null)
                {
                  datedestination = data[i].destination.date;
                }
                //console.log("date",datesource,datedestination, month, year);
                  if(datesource!=null && datesource.month == month && datesource.year == year)
                  {
                  totalShipment++;
                  //console.log("totalShipment datesource",totalShipment);
                  if(data[i].cashCollected)
                  {
                    totalCash = totalCash + data[i].cashCollected;
                    this.credit = this.credit + data[i].cashCollected;
                  }
                  }
                  else if(datedestination!=null && datedestination.month == month && datedestination.year == year) 
                  {
                    totalShipment++;
                    //console.log("totalShipment datedestination",totalShipment);
                    if(data[i].cashCollected)
                    {
                      totalCash = totalCash + data[i].cashCollected;
                      this.credit = this.credit + data[i].cashCollected;
                    }
                  }
              }
              y["totalCash"] = totalCash;
              y["totalShipment"] = totalShipment;
              this.branchWiseShipmentsForCurrentMonth.push(y);
              //console.log("branchWiseShipmentsForCurrentMonth date today",this.branchWiseShipmentsForCurrentMonth);
            }
            else
            {
              //console.log("data.length",0);
              var y = element.payload.toJSON();
              y["totalShipment"] = 0;
              y["totalCash"] = 0;
              this.branchWiseShipmentsForCurrentMonth.push(y);
              //console.log("branchWiseShipmentsForCurrentMonth",this.branchWiseShipmentsForCurrentMonth);
            }
          });
        });
        setTimeout(() => {
          this.findBranchPerformance();
        }, 3000);
      });
  }
  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed
    if (changes['month']) {
      //console.log("month",this.month);
        this.getBranchDetails(this.month);
        this.getNewCustomers(this.month);
    }
}
findBranchPerformance()
{
  var leadingBranch = this.branchWiseShipmentsForCurrentMonth[0];
  var laggingBranch = this.branchWiseShipmentsForCurrentMonth[0];
  this.branchWiseShipmentsForCurrentMonth.forEach((branch)=>{
    if(branch.totalCash >= leadingBranch.totalCash)
    {
      leadingBranch = branch;
    }
    if(branch.totalCash <=  laggingBranch.totalCash)
    {
      laggingBranch = branch;
    }
  });
  //console.log(leadingBranch, laggingBranch);
  if(leadingBranch!=null)
  {
    this.leadBranchName = leadingBranch.name;
  }
  if(laggingBranch!=null)
  {
    this.lagBranchName = laggingBranch.name;
  }
  
}
getNewCustomers(month)
{
  var year = this.currentDate.getFullYear();
  firebase.database().ref("users").orderByChild("role").equalTo("customer").on("value",(data)=>{
    var customers = data.val();
    this.customerCount =0;
    for(let i in customers)
    {
      if(customers[i].date !=null && customers[i].date.month == month && customers[i].date.year == year)
      {
        this.customerCount++;
      }
    }
    //console.log("customerCount",this.customerCount);
  });
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/dashboard-main/section3-2/section3-2.component.ts